module.exports = __webpack_public_path__ + "img/1547069622.7bf1fe87.jpg";